import {
  Button,
  createTheme,
  MantineColorsTuple,
  DEFAULT_THEME,
  mergeMantineTheme,
  SegmentedControl,
  Badge,
} from "@mantine/core";

import classes from "./segmented-control.module.css";

const brandColor: MantineColorsTuple = [
  "#efeefc",
  "#dad8f2",
  "#b3ade7",
  "#897fdd",
  "#6659d5",
  "#5041d0",
  "#4534cf",
  "#3728b7",
  "#3023a4",
  "#1b1464",
];

const themeOverride = createTheme({
  fontFamily: "'SF Pro', sans-serif",
  autoContrast: true,
  luminanceThreshold: 0.4,
  defaultRadius: "md",
  primaryShade: 9,
  primaryColor: "brand",
  colors: {
    brand: brandColor,
    light: [
      "#eadcce",
      "#f1e6db",
      "#e2d2c2",
      "#d9c7b6",
      "#cfbdac",
      "#c4b3a2",
      "#b8a99a",
      "#ab9f92",
      "#9e948b",
      "#8f8a85",
    ],
    orange: [
      "#FEF7EE",
      "#FEEDDB",
      "#FCDAB3",
      "#FBC78C",
      "#F9B464",
      "#F8A13D",
      "#EA8108",
      "#AA5E06",
      "#6A3B04",
      "#2A1702",
    ],
  },
  components: {
    Title: {
      styles: {
        root: {
          fontFamily: "'Darker Grotesque', sans-serif",
          fontWeight: 900,
        },
      },
    },
    Button: Button.extend({
      styles: {
        root: {
          fontWeight: 590,
        },
      },
    }),
    SegmentedControl: SegmentedControl.extend({
      classNames: {
        root: classes.root,
        control: classes.control,
        label: classes.label,
        innerLabel: classes.innerLabel,
        indicator: classes.indicator,
      },
    }),
    Badge: Badge.extend({
      styles: {
        root: {
          cursor: "inherit",
        },
        label: {
          textTransform: "none",
          fontWeight: 400,
        },
      },
    }),
  },
});

export const myTheme = mergeMantineTheme(DEFAULT_THEME, themeOverride);
